import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('app', ['hiddenFields']),
  },
  methods: {
    isFieldVisible(key) {
      const hiddenFields = this.hiddenFields[this.hiddenFieldsDomain] || [];

      return hiddenFields.indexOf(key) === -1;
    },
  },
};
